<script>
//CampaignChannel.vue
import { mapGetters } from 'vuex';
import globalConfigMixin from 'shared/mixins/globalConfigMixin';

export default {
  mixins: [globalConfigMixin],
  props: {
    templateName: {
      type: String,
      default: '',
    },
    channelType: {
      type: String,
      default: 'whatsapp_official',
      validator: value => ['whatsapp_app', 'whatsapp_official'].includes(value),
    },
    campaignRoutes: {
      type: Object,
      default() {
        // Usar uma função para poder acessar this.channelType
        const baseRoutes = {
          whatsapp_official: {
            CAMPAIGN_TYPE: 'campaigns_whatsapp_official_home_create',
            CONFIGURE_LIST: 'campaigns_whatsapp_official_configure_list',
            SCHEDULE: 'campaigns_whatsapp_official_schedule_step',
            FINISH: 'campaigns_whatsapp_official_finish',
          },
          whatsapp_app: {
            CAMPAIGN_TYPE: 'campaigns_whatsapp_app_home_create',
            CONFIGURE_LIST: 'campaigns_whatsapp_app_configure_list',
            SCHEDULE: 'campaigns_whatsapp_app_schedule_step',
            FINISH: 'campaigns_whatsapp_app_finish',
          }
        };
        
        return baseRoutes[this.channelType] || baseRoutes.whatsapp_official;
      },
    },
  },
  computed: {
    ...mapGetters({
      globalConfig: 'globalConfig/get',
    }),
    // O step "Configurar Lista" tem múltiplas rotas conforme a origem da base
    // (lista/tags, Google Sheets, banco de dados). O wizard precisa destacar o
    // step 2 em qualquer uma delas.
    configureStepRoutes() {
      const byChannel = {
        whatsapp_official: [
          'campaigns_whatsapp_official_configure_list',
          'campaigns_whatsapp_official_configure_google_sheets',
        ],
        whatsapp_app: [
          'campaigns_whatsapp_app_configure_list',
          'campaigns_whatsapp_app_configure_google_sheets',
          'campaigns_whatsapp_app_configure_database',
        ],
      };
      return byChannel[this.channelType] || [this.campaignRoutes.CONFIGURE_LIST];
    },
    createFlowSteps() {
      const steps = ['CAMPAIGN_TYPE', 'CONFIGURE_LIST', 'SCHEDULE', 'FINISH'];

      return steps.map(step => {
        // Definir o prefixo baseado no channelType
        const translationPrefix =
          this.channelType === 'whatsapp_app'
            ? 'CAMPAIGN.WHATSAPP_APP.CREATE_FLOW'
            : 'CAMPAIGN.WHATSAPP_OFFICIAL.CREATE_FLOW';

        const route = this.campaignRoutes[step];

        return {
          title: this.$t(`${translationPrefix}.${step}.TITLE`),
          body: this.$t(`${translationPrefix}.${step}.BODY`),
          route,
          routes: step === 'CONFIGURE_LIST' ? this.configureStepRoutes : [route],
        };
      });
    },
    items() {
      return this.createFlowSteps.map(item => ({
        ...item,
        body: this.useInstallationName(
          item.body,
          this.globalConfig.installationName
        ),
      }));
    },
  },
};
</script>

<template>
  <div
    class="flex flex-row overflow-auto p-4 h-full bg-slate-25 dark:bg-slate-800"
  >
    <woot-wizard
      class="hidden md:block w-1/4 shrink-0 grow-0 basis-1/4"
      :global-config="globalConfig"
      :items="items"
    />
    <router-view />
  </div>
</template>